import { render, staticRenderFns } from "./AppShowcaseCard.vue?vue&type=template&id=15f66399&scoped=true"
import script from "./AppShowcaseCard.vue?vue&type=script&lang=js"
export * from "./AppShowcaseCard.vue?vue&type=script&lang=js"
import style0 from "./AppShowcaseCard.vue?vue&type=style&index=0&id=15f66399&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f66399",
  null
  
)

export default component.exports